import type { ColumnDef } from '@tanstack/react-table'
import type { InternalRole } from '@/hooks/useInternalUsers'
import { Badge } from '@/components/ui/badge'
import { CheckCircle2 } from 'lucide-react'

const statusStyles: Record<'active' | 'inactive', string> = {
    active: 'bg-green-100 text-green-700 hover:bg-green-100',
    inactive: 'bg-gray-100 text-gray-700 hover:bg-gray-100',
}

export const roleColumns: ColumnDef<InternalRole>[] = [
    {
        accessorKey: 'id',
        header: 'Role ID',
        cell: ({ row }) => (
            <span className="font-mono text-xs text-[#0F172A]">
                #{row.original.id}
            </span>
        ),
    },
    {
        accessorKey: 'title',
        header: 'Role title',
        cell: ({ row }) => (
            <span className="text-sm text-[#0F172A]">{row.original.title}</span>
        ),
    },
    {
        accessorKey: 'assignedUsers',
        header: 'No of assigned users',
        cell: ({ row }) => (
            <span className="text-sm text-[#0F172A]">
                {row.original.assignedUsers}
            </span>
        ),
    },
    {
        accessorKey: 'isActive',
        header: 'Status',
        cell: ({ row }) => {
            const statusLabel = row.original.isActive ? 'Active' : 'Inactive'
            const style = row.original.isActive
                ? statusStyles.active
                : statusStyles.inactive
            return (
                <Badge variant="secondary" className={style}>
                    <CheckCircle2 className="mr-1 h-3 w-3" />
                    {statusLabel}
                </Badge>
            )
        },
    },
]
